module.exports = "<div class=\"recipeDetail-image\"\r\n    ng-style=\"{'background-image': 'url(' + ($ctrl.breakpointsService.isInSmallFormat ? $ctrl.recipe.MediumImageFilename : $ctrl.recipe.LargeImageFilename) + ')'}\">\r\n    <meta itemprop=\"image\" content=\"{{::$ctrl.recipe.ImageFilename}}\"></meta>\r\n    <meta itemprop=\"description\" content=\"{{::$ctrl.recipe.Description}}\"></meta>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/recipe/detail-templates/default-header.html
// module id = 88
// module chunks = 0 2